import { Tooltip, Typography, Link } from "@mui/material";
import { IListItem } from "models/common"
import { useState } from "react";
import { Link as RouterLink } from 'react-router-dom';

type TaskListTooltipProps = {
    list: IListItem[];
    hide?: boolean;
    showHyperlink?: boolean;
};

const TaskListTooltip = (props: TaskListTooltipProps) => {
    const {
        list,
        showHyperlink
    } = props;
    const [showTooltip, setShowTooltip] = useState(false);
    const handleTooltipOpen = () => {
        setShowTooltip(true);
    };

    const handleTooltipClose = () => {
        setShowTooltip(false);
    };

    const first = list.length >= 1 
        ? list[0] : null;

    return (
        <Tooltip
            title={
                <ul
                    style={{ fontSize: '14px', paddingRight: '20px' }}>
                    {list?.map((item) => (
                        <li key={item.id}>{item.name}</li>
                    ))}
                </ul>
            }
            open={showTooltip}
            onClose={handleTooltipClose}
            disableFocusListener
            disableHoverListener={!list?.length}
            disableTouchListener={!list?.length}
        >
            <Typography
                onMouseEnter={handleTooltipOpen}
                onMouseLeave={handleTooltipClose}
            >
                { first 
                    ? <>{
                        showHyperlink && <Link component={RouterLink} to={`/tasks/${first.id}`}>
                            {first.name}
                        </Link>
                        ||
                        <label>{first.name}</label>
                    }</> 
                    : null
                }
            </Typography>
        </Tooltip>
    );
};

export default TaskListTooltip;